<p-skeleton height="250px" borderRadius="8px" [style]="{ cursor: 'wait' }" />
